// extracted by mini-css-extract-plugin
export default {"kpiDashboard":"sidebar_kpiDashboard__nqxEN"};